module.exports = __webpack_public_path__ + "img/soul.0e53c7a3.png";